import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';

type DeviceBlueprintDataEndpointSpecification = ApiEndpointSpecification;
export const DeviceBlueprintDataEndpointSpecification: DeviceBlueprintDataEndpointSpecification = {
    url: '/api/sierraDevice/masterblueprints',
    method: HttpMethod.POST,
    requestParamsSchemaName: 'DeviceBlueprintDataRequestParams',
    requestBodySchemaName: 'DeviceBlueprintDataRequestBody',
    okResponseSchemaName: 'DeviceBlueprintDataOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version: 1.0,
};

export const invokeDeviceBlueprint = Helpers.makeApiRequestFn<
    Types.DeviceBlueprintDataRequestParams,
    Types.DeviceBlueprintDataRequestBody,
    Types.DeviceBlueprintDataOkResponse
>(DeviceBlueprintDataEndpointSpecification);
